import { fetchData } from './AdvWorkflowActions';

export const INITIALIZE = 'WORKFLOW_CACHE.INITIALIZE';
export const SET_DIRTY_FLAG_FOR_ALL = 'WORKFLOW_CACHE.SET_DIRTY_FLAG_FOR_ALL';
export const CLEAR_DIRTY_FLAG_FOR_ALL = 'WORKFLOW_CACHE.CLEAR_DIRTY_FLAG_FOR_ALL';

export const initialize = () => ({ type: INITIALIZE });
export const setDirtyFlagForAll = nodes => ({ type: SET_DIRTY_FLAG_FOR_ALL, nodes });
export const clearDirtyFlagForAll = nodes => ({ type: CLEAR_DIRTY_FLAG_FOR_ALL, nodes });

export const fetchDataIfNecessary = (
  workflowId,
  clientId,
  nodeArray,
  dirtyNodesMap,
  showSpinner,
) => dispatch => {
  const touchedNodes = [];
  nodeArray.forEach(node => {
    if (dirtyNodesMap[node]) {
      touchedNodes.push(node);
    }
  });
  if (touchedNodes.length) {
    dispatch(clearDirtyFlagForAll(touchedNodes));
    dispatch(fetchData(workflowId, clientId, touchedNodes, showSpinner));
  }
};
